<kz-sticker stickerContext="{{boxable ? 'dark' : 'decorator'}}">
  <span *ngIf="from" firstLine i18n="@@pro.listing.price.from">From</span>
  <strong *ngIf="service.priceType == priceType.PriceNumber">{{ service.priceNumber | currency: 'EUR':'symbol':'1.0-2' }}</strong>
  <strong *ngIf="service.priceType == priceType.PriceText"><ng-container *ngIf="service.priceText;then new else old"></ng-container></strong>
  <strong *ngIf="service.priceType == priceType.Quotation" i18n="@@service.quotation">On quotation</strong>
</kz-sticker>
<ng-template #new>{{ service.priceText }}</ng-template>
<ng-template #old>{{ service.price }}</ng-template>
